import React from 'react';
import { connect } from 'react-redux';
import { Page, PageBody, PageContent } from '@bit/knotchinc.web-react-components.page';
import Text from '@bit/knotchinc.web-react-components.text';
import FilterSideMenu from '@bit/knotchinc.web-react-components.filter-side-menu';
import DateFilter from '@bit/knotchinc.web-react-components.date-filter';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import Mixpanel from 'helpers/Mixpanel.js';
import ContentCard from 'components/Global/Card/ContentCard.jsx';
import PageHeader from 'components/Global/PageHeader/PageHeader.jsx';
import ContentFilter from 'components/Global/Filters/ContentFilter/ContentFilter.jsx';
import ArticleOptionsFilter from 'components/Global/Filters/ArticleOptionsFilter/ArticleOptionsFilter.jsx';
import TagFilter from 'components/Global/Filters/TagFilter/TagFilter.jsx';
import ChecklistFilter from 'components/Global/Filters/ChecklistFilter/ChecklistFilter.jsx';
import EntityFilter from 'components/Global/Filters/EntityFilter/EntityFilter.jsx';
import SearchFilter from 'components/Global/Filters/SearchFilter/SearchFilter.jsx';
import SelectedFiltersBar from 'components/Global/Filters/SelectedFiltersBar/SelectedFiltersBar.jsx';
import { SET_KEYWORDS_FILTER, SET_BRANDS_FILTER, SET_PUBLISHERS_FILTER, SET_CATEGORIES_FILTER } from 'components/Global/Filters/actions.js';
import { articleLengthToWordCount, numberWithCommas } from 'helpers/Utils.js';
import { ContentFeedContainer } from '../Home/styled.js';
import { fetchSearchKeywords, fetchSearchPublishers, fetchSearchCategories,
  fetchSearchBrands, fetchSearchFeed, SET_SEARCH_FEED_FILTER } from './actions.js';

export class SearchFeedView extends React.Component {
  componentDidMount() {
    Mixpanel.track('view Search Feed');
  }

  render() {
    const { contentList, categoriesList, keywordsList, brandsList, publishersList,
      getPublishers, getBrands, getCategories, getKeywords, getFeed } = this.props;
    const currentFilters = contentList.filters;
    const contentListLength = contentList && contentList.pagination ? contentList.pagination.total : null;
    const title = (
      <span>
        <Text color="palette.5" display="inline-block" mr="12px">
          Search
        </Text>
        {contentListLength ? `${numberWithCommas(contentListLength)} Results` : null}
      </span>
    );

    return (
      <Page>
        <PageHeader title={title} fetched />
        <PageBody>
          <FilterSideMenu clearAll={() => {}}>
            <DateFilter filterAction={SET_SEARCH_FEED_FILTER} filters={currentFilters} />
            <SearchFilter title="Search Content Titles" filterAction={SET_SEARCH_FEED_FILTER} />
            <TagFilter
              title="keywords"
              type="keyword_tags"
              filters={keywordsList.filters}
              items={keywordsList}
              fetch={clear => getKeywords(clear)}
              selectedItems={currentFilters.keyword_tags}
              filterAction={SET_SEARCH_FEED_FILTER}
              listAction={SET_KEYWORDS_FILTER}
            />
            <ChecklistFilter
              type="categories"
              filters={categoriesList.filters}
              items={categoriesList}
              fetch={clear => getCategories(clear)}
              selectedItems={currentFilters.categories}
              filterAction={SET_SEARCH_FEED_FILTER}
              listAction={SET_CATEGORIES_FILTER}
            />
            <EntityFilter
              title="brands"
              type="brand_ids"
              filters={brandsList.filters}
              items={brandsList}
              fetch={clear => getBrands(clear)}
              selectedItems={currentFilters.brand_ids}
              filterAction={SET_SEARCH_FEED_FILTER}
              listAction={SET_BRANDS_FILTER}
            />
            <EntityFilter
              title="publishers"
              type="publisher_ids"
              filters={publishersList.filters}
              items={publishersList}
              fetch={clear => getPublishers(clear)}
              selectedItems={currentFilters.publisher_ids}
              filterAction={SET_SEARCH_FEED_FILTER}
              listAction={SET_PUBLISHERS_FILTER}
            />
            <ContentFilter
              type="content"
              filters={currentFilters}
              filterAction={SET_SEARCH_FEED_FILTER}
            />
            <ArticleOptionsFilter
              title="Article Length"
              filters={currentFilters}
              filterAction={SET_SEARCH_FEED_FILTER}
              type="article_length"
              options={[
                { text: articleLengthToWordCount.short, value: 'short' },
                { text: articleLengthToWordCount.medium, value: 'medium' },
                { text: articleLengthToWordCount.long, value: 'long' },
              ]}
            />
            <ArticleOptionsFilter
              title="Content Format"
              filters={currentFilters}
              filterAction={SET_SEARCH_FEED_FILTER}
              type="content_format"
              options={[
                { text: 'Article', value: 'article' },
                { text: 'Video', value: 'video' },
              ]}
            />
          </FilterSideMenu>
          <PageContent>
            <SelectedFiltersBar filters={currentFilters} filterAction={SET_SEARCH_FEED_FILTER} />
            <ContentFeedContainer>
              <ListSync
                fetch={clear => getFeed(clear)}
                listStore={contentList}
                loadOnScroll
                actionType={SET_SEARCH_FEED_FILTER}
                loadingPlaceholders={12}
              >
                <ContentCard />
              </ListSync>
            </ContentFeedContainer>
          </PageContent>
        </PageBody>
      </Page>
    );
  }
}

const mapStateToProps = ({
  PublishersList: { publishersList },
  BrandsList: { brandsList },
  KeywordsList: { keywordsList },
  CategoriesList: { categoriesList },
  SearchFeed: { contentList },
}) => ({ contentList, publishersList, categoriesList, keywordsList, brandsList });

const mapDispatchToProps = dispatch => ({
  getFeed: clear => dispatch(fetchSearchFeed(clear)),
  getKeywords: clear => dispatch(fetchSearchKeywords(clear)),
  getCategories: clear => dispatch(fetchSearchCategories(clear)),
  getBrands: clear => dispatch(fetchSearchBrands(clear)),
  getPublishers: clear => dispatch(fetchSearchPublishers(clear)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchFeedView);
